[
    {
        "llm": "open-ai",
        "name": "OpenAI",
        "models": ["gpt-4o"],
        "embeedModels": ["text-embedding-3-small"],
        "icon":"custom:openai"
    },
    {
        "llm": "gemini",
        "name": "Gemini",
        "models": ["gemini-1.5-pro", "gemini-1.5-pro-code"],
        "embeedModels": ["gemini-1.5-pro-embed"],
        "icon":"custom:gemini"
    },
    {
        "llm": "antropic",
        "name": "Anthropic",
        "models": ["claude-2", "claude-instant-100k"],
        "embeedModels": []
    },
    {
        "llm": "llama",
        "name": "Llama",
        "models": ["llama-3.1"],
        "embeedModels": []
    },
    {
        "llm": "deepseek",
        "name": "DeepSeek",
        "models": ["ds-gpt-3.5"],
        "embeedModels": ["ds-embed-3.5"]
    },
    {
        "llm": "qwen",
        "name": "Qwen",
        "models": ["qwen-2.5"],
        "embeedModels": ["qwen-2.5-embed"]
    }
]